export enum DashboardType {
    SetupDashboard = 0,
    HouseholdDashboard = 1
}